<div class="d-flex align-items-center justify-content-between px-3 pt-3 pb-2">
  <h1 mat-dialog-title class="mb-0">
    {{ 'ADMIN_ADD_ACHIEVEMENT.' + (achievement.id ? 'EDIT_TITLE' : 'ADD_TITLE') | translate }}
  </h1>
</div>

<div mat-dialog-content class="px-3">
  <form #dialogForm="ngForm">
    <div class="row justify-content-center mb-3">
      <div class="col-auto">
        <div class="achievement__icon">
          <app-image-picker
            keyPrefix="achievements"
            [image]="achievement.icon"
            (onImageSelect)="onAchievementIconSelect($event)"
          ></app-image-picker>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <mat-form-field class="w-100">
          <input
            type="text"
            matInput
            cdkFocusInitial
            [placeholder]="'ADMIN_ADD_ACHIEVEMENT.TITLE_INPUT_PLACEHOLDER' | translate"
            [(ngModel)]="achievement.title"
            name="title"
            required
          />
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field class="w-100">
          <input
            type="text"
            matInput
            [placeholder]="'ADMIN_ADD_ACHIEVEMENT.DESCRIPTION_INPUT_PLACEHOLDER' | translate"
            [(ngModel)]="achievement.description"
            name="description"
            required
          />
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="errorMessage" class="alert alert-danger mt-2" role="alert">
      <mat-icon class="alert-icon">error_outline</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>
  </form>
</div>

<div mat-dialog-actions class="d-flex justify-content-end gap-2 px-3 pb-3">
  <button mat-stroked-button mat-dialog-close>{{ 'BUTTON.CANCEL' | translate }}</button>
  <button
    mat-raised-button
    color="primary"
    (click)="saveAchievement()"
    [disabled]="!dialogForm.valid || dialogForm.untouched || !achievement.icon"
  >
    {{ 'BUTTON.SAVE' | translate }}
  </button>
</div>
